import * as React from 'react';

const AngryFace48 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 48 48", width: 48, height: 48, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M26.573 26.595a1.25 1.25 0 0 1 1.415-.019l5.648 3.766a1.25 1.25 0 1 1-1.386 2.08l-4.934-3.29-5.89 4.162a1.25 1.25 0 0 1-1.414.02l-5.648-3.766a1.25 1.25 0 0 1 1.387-2.08l4.934 3.29zm-9.513-5.371a2.313 2.313 0 1 0 0-4.626 2.313 2.313 0 0 0 0 4.626m13.88 0a2.313 2.313 0 1 0 0-4.626 2.313 2.313 0 0 0 0 4.626"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M42.996 24c0 10.491-8.505 18.996-18.996 18.996S5.004 34.491 5.004 24 13.509 5.004 24 5.004 42.996 13.509 42.996 24M24 40.496c9.11 0 16.496-7.386 16.496-16.496S33.11 7.504 24 7.504 7.504 14.89 7.504 24 14.89 40.496 24 40.496"
  }
));
AngryFace48.Size = 48;
AngryFace48.Title = "AngryFace";

export { AngryFace48 as default };
